import React, { useState, useEffect } from "react";
import NavBar from "./Components/NavBar";
import ItemEvento from "./Components/ItemEvento";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useNavigate, Link } from "react-router-dom";
import {
  collection,
  getDocs,
  doc,
  deleteDoc,
  query,
  where,
} from "firebase/firestore";
import { db } from "./FirebaseConfig/firebase";
import "./CSS/eventos.css";
const MySwal = withReactContent(Swal);

function EventosCDA() {
  const navigate = useNavigate();
  //configurar useState
  const [eventos, setEventos] = useState([]);
  const [eventosInactivos, setEventosInacticvos] = useState([]);
  const [datosCargados, setDatosCargados] = useState(false); // MOSTRAR BARRA DE CARGA

  //referenciar la DB
  const eventosList = collection(db, "EVENTOS");

  //funcion para mostrar la lista de eventos
  const getEventos = async () => {
    const data = await getDocs(eventosList);
    setEventos(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
  };
  const getActivos = async () => {
    const eventosFiltrados = query(
      eventosList,
      where("estado", "==", "Activo")
    );
    const data = await getDocs(eventosFiltrados);
    setEventos(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
  };
  const getInactivos = async () => {
    const eventosFiltrados = query(
      eventosList,
      where("estado", "==", "Inactivo")
    );
    const data = await getDocs(eventosFiltrados);
    setEventosInacticvos(
      data.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
    );
    setDatosCargados(true);
  };
  //Funcion para eliminar evento
  const deleteEvento = async (id) => {
    const evento = doc(db, "EVENTOS", id);
    await deleteDoc(evento);
    getActivos();
    getInactivos();
  };
  //Funcion para editar evento
  const editEvento = async (id) => {
    //
    /*const evento = doc(db, "CUPONES", id);
    await deleteDoc(evento);
    getEventos();*/
  };

  //Alert eliminar evento
  const confirmDelete = (id) => {
    MySwal.fire({
      title: "Eliminar evento?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, eliminar! ",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteEvento(id);
        Swal.fire({
          position: "center",
          icon: "success",
          title: "El evento ha sido eliminado",
          showConfirmButton: false,
          timer: 1000,
        });
      }
    });
  };
  //cerrar eventos
  const cerrar = () => {
    navigate("../panelCDA");
  };
  //uso de useEffect
  useEffect(() => {
    getActivos();
    getInactivos();
  }, []);
  if (!datosCargados) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "0px auto",
          textAlign: "center",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ verticalAlign: "middle", display: "block" }}>
          <div>
            <img
              style={{ height: "300px" }}
              src={require(`./img/docucargando.gif`)}
              alt="esperando"
            />
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="eventos">
      <NavBar
        titulo="Eventos"
        imagen="cerrar"
        logoTitulo="eventos"
        cerrar={cerrar}
      ></NavBar>
      <div className="evento-cabecera">
        <p style={{ marginTop: "50px", marginLeft: "70px" }}>EVENTOS ACTIVOS</p>
      </div>
      {eventos.length == 0 ? (
        <div >
          <p style={{ marginTop: "50px", textAlign: "center" }}>
            No hay eventos activos
          </p>
        </div>
      ) : null}

      <div className="eventos-grid-container">
        {eventos.map((item) => (
          <div className="eventos-element">
            <ItemEvento
              nombre={item.nombre}
              fecha={item.fecha}
			  hora={item.hora}

              descripcion={item.descripcion}
              id={item.id}
              deleteEvento={confirmDelete}
              imagen={item.urlImagen}
              salon={item.salon}
            />
          </div>
        ))}
      </div>
      <div className="evento-cabecera">
        <p style={{ marginTop: "50px", marginLeft: "70px" }}>
          EVENTOS INACTIVOS
        </p>
      </div>
      <div className="eventos-grid-container">
        {eventosInactivos.map((item) => (
          <div className="eventos-element">
            <ItemEvento
              nombre={item.nombre}
              fecha={item.fecha}
              descripcion={item.descripcion}
              id={item.id}
              deleteEvento={confirmDelete}
              imagen={item.urlImagen}
              salon={item.salon}
            />
          </div>
        ))}
      </div>
      <Link
        className="eventos-flotante"
        to={`/panelAdmin/eventos/agregarEvento`}
      >
        <img
          src={require(`./img/plus.png`)}
          className="eventos-boton"
          border="0"
        />
      </Link>
    </div>
  );
}
export default EventosCDA;
